import { SerializedStyles, css } from "@emotion/react";
import { ellipsis } from "polished";

import { DesignToken, RadiusToken, ShadowToken, SpacingToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const tagListContainerStyles = (isVisible = true): SerializedStyles => css`
  display: ${isVisible ? "block" : "none"};
  border-radius: var(${RadiusToken.Radius3});
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
  box-shadow: ${withVar(ShadowToken.PopOver)};
  padding: ${withVar(SpacingToken.Spacing2)};
`;

export const dropdownListStyles = (isVisible = true): SerializedStyles => css`
  display: ${isVisible ? "block" : "none"};
  max-height: 352px;
  border-radius: var(${RadiusToken.Radius3});
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
  box-shadow: ${withVar(ShadowToken.PopOver)};
  padding: ${withVar(SpacingToken.Spacing2)};
  max-width: 360px;
  min-width: 90px;
`;

export const itemName = css`
  white-space: pre-wrap;
`;

export const tagName = css`
  ${itemName}
  ${ellipsis()}
  width: 100%;
  padding: 0 10px;
`;

const itemArrow = css`
  position: relative;
  top: 7px;
`;

export const tagArrow = css`
  ${itemArrow}
  margin-left: auto;
`;

export const loaderContainerStyles = css`
  align-items: center;
  box-shadow: ${withVar(ShadowToken.PopOver)};
  display: flex;
  font-size: 14px;
  justify-content: center;
  line-height: 22px;
  padding: 0 10px;
`;

export const circleLoaderContainerStyles = css`
  width: 14px;
  height: 14px;
  display: inline-block;
  margin-right: 5px;
`;

export const circleLoaderStyles = css`
  position: relative;
  border-width: 2px;
  border-color: ${withVar(DesignToken.ActionPrimaryDisabled)};
  border-top-color: ${withVar(DesignToken.ActionPrimaryDefault)};
  transition: all 0.2s ease-in-out;
`;
